import { store } from '../store/store'
import { IntegrationType } from '../@types/config'
import {
  updateBusinessArea,
  updateFormPage,
  updateFormType,
  updateFormUrl,
  updateIv24Intention,
  updateQcTransactionId,
} from '../store/immoverkauf24/trackingSlice'
import { BusinessArea, Iv24Intention } from '../@types/ownerBackendReceiveLeadRequest'

export const updateStoreWithIv24StaticTracking = (integrationType: IntegrationType) => {
  if (integrationType === IntegrationType.IMMOVERKAUF24) {
    const qcTransactionId: string = crypto.randomUUID()
    store.dispatch(updateBusinessArea(BusinessArea.SALE))
    store.dispatch(updateFormType('Immobilienbewertung IS24'))
    store.dispatch(updateIv24Intention(Iv24Intention.SELL))
    store.dispatch(updateQcTransactionId(qcTransactionId))
    store.dispatch(updateFormUrl(window.location.href))
    store.dispatch(updateFormPage(document.title))
  }
}
